<div class="page-wrapper"> <app-bees-header></app-bees-header>
    <div class="stricky-header stricked-menu main-menu">
        <div class="sticky-header__content"></div>
    </div> <!-- Page Header -->
    <section class="page-header">
        <div class="page-header__bg" style="background-image: url(assets/images/backgrounds/page-header-bg.jpg);">
        </div>
        <div class="container">
            <div class="page-header__inner">
                <div class="page-header__img-1"> <img src="assets/images/resources/page-header-img-1.png" alt=""> </div>
                <div class="page-header__shape-1 float-bob-y"> <img src="assets/images/shapes/page-header-shape-1.png"
                        alt=""> </div>
                <h3>Thermal Paper Roll</h3>
                <div class="thm-breadcrumb__inner">
                    <ul class="thm-breadcrumb list-unstyled">
                        <li> <a href="index.html">Home</a> </li>
                        <li> <span class="fas fa-angle-right"></span> </li>
                        <li> <a href="services.html">Products</a> </li>
                        <li> <span class="fas fa-angle-right"></span> </li>
                        <li> <a href="services.html">Thermal Roll</a> </li>
                        <li> <span class="fas fa-angle-right"></span> </li>
                        <li>Plain Roll</li>
                    </ul>
                </div>
            </div>
        </div>
    </section> <!-- Service Details -->
    <section class="service-details">
        <div class="container">
            <div class="row"> <!-- LEFT SIDEBAR -->
                <div class="col-xl-4 col-lg-5">
                    <div class="service-details__sidebar">
                        <div class="service-details__services-box">
                            <h3 class="service-details__services-title">Plain Thermal Paper Roll </h3>
                            <ul class="service-details__services-list list-unstyled">
                                <li [class.active]="activeSection === 'pepper'"> <a (click)="goToSection('pepper')"> 2
                                        Inch <span class="icon-next"></span> </a> </li>
                                <li [class.active]="activeSection === 'cardamom'"> <a (click)="goToSection('cardamom')">
                                        3 Inch <span class="icon-next"></span> </a> </li>
                                <li [class.active]="activeSection === 'cinnamon'"> <a (click)="goToSection('cinnamon')">
                                        4 Inch <span class="icon-next"></span> </a> </li>
                            </ul>
                        </div>
                        <div class="service-details__sidebar-contact">
                            <div class="service-details__sidebar-contact-img">
                                <div class="inner"> <img src="assets/images/services/service-details-sidebar-img.png"
                                        alt=""> </div>
                            </div>
                            <div class="service-details__sidebar-contact-content">
                                <div class="icon"> <span class="icon-phone-call"></span> </div>
                                <h2> <a href="tel:09994501750"> +91 999 450 1750 </a> </h2>
                                <h2 style="color:#fd5523;"> If You Need Any Help <br> Contact With Us </h2>
                            </div>
                        </div>
                    </div>
                </div> <!-- RIGHT CONTENT -->
                <div class="col-xl-8 col-lg-7">
                    <div class="service-details__left"> <!-- PEPPER -->
                        <div *ngIf="activeSection === 'pepper'" class="product-content">
                            <div class="service-details__img"> <img
                                    src="assets/images/services/service-details-img-1.jpg" alt=""> </div>
                            <h3 class="service-details__title-1"> 2 Inch Plain Thermal Paper Roll </h3>
                            <p class="service-details__text-1"> Our 2 Inch Plain Thermal Paper Rolls are manufactured
                                using premium-grade thermal paper to ensure sharp and clear printing results. Ideal for
                                POS billing machines, retail stores, supermarkets, restaurants, and business
                                transactions. These rolls provide smooth performance, excellent image retention, and
                                reliable print quality without the need for ink or ribbons. Available in various lengths
                                and bulk quantities to meet diverse business requirements. </p>
                        </div> <!-- CARDAMOM -->
                        <div *ngIf="activeSection === 'cardamom'" class="product-content">
                            <div class="service-details__img"> <img
                                    src="assets/images/services/service-details-img-2.jpg" alt=""> </div>
                            <h3 class="service-details__title-1"> 3 Inch Plain Thermal Paper Roll </h3>
                            <p class="service-details__text-1"> Premium-quality 3 Inch Thermal Paper Rolls for sharp and
                                consistent printing. Ideal for POS machines, billing counters, retail stores, and
                                restaurants. Ensures smooth operation, excellent print clarity, and reliable
                                performance. Available in bulk supply at competitive prices. </p>
                        </div> <!-- CINNAMON -->
                        <div *ngIf="activeSection === 'cinnamon'" class="product-content">
                            <div class="service-details__img"> <img
                                    src="assets/images/services/service-details-img-3.jpg" alt=""> </div>
                            <h3 class="service-details__title-1"> 4 Inch Plain Thermal Paper Roll </h3>
                            <p class="service-details__text-1"> Premium-quality 4 Inch Thermal Paper Rolls designed for
                                clear, reliable, and high-speed printing. Suitable for POS systems, billing machines,
                                logistics, and commercial applications. Ensures smooth operation, excellent print
                                clarity, and long-lasting performance. Available in bulk supply at competitive prices.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section> 
    
    
    <app-bees-footer></app-bees-footer>
</div>